
import { mapGetters, mapMutations } from 'vuex';
import FilterSelector from './FilterSelector.vue';

export default {
  name: 'ChildAgeFilter',
  components: {
    FilterSelector,
  },
  computed: {
    ...mapGetters('search/filter', ['selectedAge']),
    ...mapGetters('user', ['children']),
    childList() {
      return this.children
        .filter(child => child.age > 4)
        .map(child => {
          return {
            text: `${child.name} (${child.age}세)`,
            value: child.age,
          };
        });
    },
  },
  methods: {
    ...mapMutations('search/filter', ['SET_SELECTED_AGE']),
    setSelectedAge(value) {
      const index = this.selectedAge.indexOf(value);
      if (index === -1) {
        this.SET_SELECTED_AGE([...this.selectedAge, value]);
      } else {
        this.SET_SELECTED_AGE(this.selectedAge.filter(age => age !== value));
      }
    },
  },
};
